import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ArrowUpOnSquareIcon from "@heroicons/react/24/solid/ArrowUpOnSquareIcon";
import {
  Box,
  Button,
  Container,
  Stack,
  SvgIcon,
  Typography,
} from "@mui/material";
import { CustomersSearch } from "@/sections/customer/customers-search";
import { useGetOffersQuery } from "@/app/features/offers/offersApiSlice";
import OfferListing from "@/pages/manage-offers/components/OfferListing";
import EditOfferModal from "@/pages/manage-offers/components/EditOfferModal";

function ManageOffersPage() {
  const [search, setSearch] = useState("");
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 100,
    page: 0,
  });
  const { data, isLoading, isFetching, error } = useGetOffersQuery({
    page: paginationModel.page + 1,
    limit: paginationModel.pageSize,
    search: search,
  });

  const [rowCountState, setRowCountState] = useState(data?.count || 0);

  const [selectedCar, setSelectedCar] = useState({});
  const [isSelectedCarModal, setIsSelectedCarModal] = useState(false);

  const handleSelectedCarModalClose = () => setIsSelectedCarModal(false);

  const handleSelectCar = (car) => {
    setSelectedCar(car);
    setIsSelectedCarModal(true);
  };

  useEffect(() => {
    setRowCountState((prevRowCountState) =>
      data?.data?.total !== undefined ? data?.data?.total : prevRowCountState
    );
  }, [data, isLoading]);

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 8,
      }}
    >
      {selectedCar && (
        <EditOfferModal
          open={isSelectedCarModal}
          handleClose={handleSelectedCarModalClose}
          selectedCar={selectedCar}
        />
      )}

      <Container maxWidth="xl">
        <Stack spacing={3}>
          <Stack direction="row" justifyContent="space-between" spacing={4}>
            <Typography variant="h4">Manage Offers</Typography>
            <Button
              color="inherit"
              startIcon={
                <SvgIcon fontSize="small">
                  <ArrowUpOnSquareIcon />
                </SvgIcon>
              }
              component={Link}
              to="/offers/upload"
            >
              Import
            </Button>
          </Stack>
          <CustomersSearch search={search} setSearch={setSearch} />

          <OfferListing
            isLoading={isLoading || isFetching}
            error={error}
            data={data?.data}
            rowCountState={rowCountState}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            handleSelectCar={handleSelectCar}
          />
        </Stack>
      </Container>
    </Box>
  );
}

export default ManageOffersPage;
